import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useForm } from 'react-hook-form';
import dayjs from 'dayjs';
import RoutesApp from '../../routes';

//Servicios
import { DJCPService } from '../../services/api';

//Modelos
import NewDJCPModel from '../../models/NewDJCP';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import NewDJCP from './NewDJCP';

function NewDJCPContainer() {
    const { toast, token, grapesVariety } = useGlobalContext();
    const Navigate = useNavigate();
    const Params = useParams();

    const [loader, setLoader] = useState(false);
    const [DJCPData, setDJCPData] = useState(new NewDJCPModel());

    const FormMethods = useForm();

    const DJCPCerrada = useMemo(() => {
        return DJCPData.cabecera?.fecha_Cierre !== null;
    }, [DJCPData]);

    useEffect(() => {
        async function fetchDJCP() {
            try {
                setLoader(true);

                //Obtenemos la DJCP segun el id de los params
                const DJCP = await DJCPService.single({
                    token,
                    id: parseInt(Params.id),
                });

                if (DJCP) {
                    //Establecemos los datos para la nueva DJCP
                    const newDJCP = new NewDJCPModel({
                        cabecera: DJCP.data.cabecera,
                        items: DJCP.data.items,
                    });
                    setDJCPData(newDJCP);
                    setTableData(buildTableData(newDJCP.items));

                    //Establecemos los valores iniciales del form
                    newDJCP.items.forEach((it, i) => {
                        newDJCP[`kilos` + i] = it.kilos;
                    });
                    newDJCP.cabecera.titulares_Documento =
                        newDJCP.cabecera.titulares_Documento?.split(' / ');
                    FormMethods.reset({ ...newDJCP });
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        }

        fetchDJCP();
    }, []);

    const onSubmit = async (data) => {
        try {
            setLoader(true);
            //Formacion del objeto para enviar en la peticion
            const DJCPUpdated = new NewDJCPModel(data);

            DJCPUpdated.items.forEach((it, i) => {
                it.kilos = parseInt(data[`kilos` + i]);
            });
            DJCPUpdated.cabecera.titulares_Documento =
                data.cabecera.titulares_Documento.join(' / ');

            //Peticion para actualizar la DJCP
            const updateDJCP = await DJCPService.update({
                token,
                declaracion: DJCPUpdated,
            });

            //Si la respuesta es correcta, navegamos denuevo a la tabla de DJCPs y desplegamos mensaje de éxito
            if (updateDJCP) {
                Navigate(RoutesApp.Declaraciones.cosechaProbable);
                toast('DJCP guardada con éxito', { type: 'success' });
            }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            console.log(err);
            return err;
        }
    };

    /**Funcion que crea el objeto para pasarle a la tabla que lista las DJCPs */
    const buildTableData = (
        data = [
            { id: 0, variedad: 0, superficie: 0, kilos: 0, id_declaracion: 0 },
        ]
    ) => {
        return {
            headers: ['Variedad de Uva', 'Superficie', 'Kilos Probables'],
            pagination: 100,
            data: data?.map((dj, i) => {
                return {
                    variedad: grapesVariety?.find(
                        (gv) => gv.codigo === dj.variedad
                    )?.variedad,
                    superficie: `${dj.superficie} m²`,
                    kilos: (
                        <input
                            {...FormMethods.register(`kilos` + i)}
                            type={'number'}
                            disabled={DJCPCerrada}
                        />
                    ),
                };
            }),
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    return loader ? (
        <Spinner />
    ) : (
        <NewDJCP
            functions={{
                ...FormMethods,
                onSubmit,
            }}
            states={{ tableData, DJCPData, DJCPCerrada }}
        />
    );
}

export default NewDJCPContainer;
